// src/hooks/rq/useFavorites.js

import { useQuery } from '@tanstack/react-query';
import API from '../../api/client';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';  // Importa AuthContext

/**
 * Petición a GET /favorites/ enviando lat/lng si existen.
 */
const fetchFavorites = async ({ queryKey }) => {
  const [, lat, lng] = queryKey;
  const params = {};
  if (lat !== 'none' && lng !== 'none') {
    params.lat = lat;
    params.lng = lng;
  }
  const { data } = await API.get('/favorites/', { params });
  return data;
};

/**
 * Hook para leer favoritos con React Query, sin refetch automático
 * en cada montaje ni al enfocar la ventana, y sólo si hay sesión.
 *
 * @param {{ lat: number, lng: number }} location
 */
export function useFavorites(location) {
  const { isAuthenticated } = useContext(AuthContext);
  const latKey = location.lat  ?? 'none';
  const lngKey = location.lng  ?? 'none';

  return useQuery({
    queryKey: ['favorites', latKey, lngKey],
    queryFn: fetchFavorites,

    // 1️⃣ Sólo lanzar la query cuando el usuario esté autenticado
    enabled: isAuthenticated,

    // 2️⃣ Evitar reintentos infinitos ante un 401
    retry: (failureCount, error) => {
      // si es un 401, no reintentamos
      if (error?.response?.status === 401) return false;
      // en otro caso, hasta 2 reintentos
      return failureCount < 2;
    },

    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
}
